export default __webpack_public_path__ + "static/media/Group 8248.bc054848.svg";